import { Divider, Heading, Stack } from '@chakra-ui/react';

import SportsFormFields from './Sports/SportsFormFields';
import { SourceConfig } from '.';

const MultiDataSourcesForm = ({
  firstFieldRef,
  onCancel,
  sources,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firstFieldRef: React.RefObject<any>;
  onCancel: () => void;
  sources: SourceConfig[];
}) => {
  return (
    <Stack spacing={4} data-test-id="configure-datasources">
      <Heading size="md">Configure Datasources</Heading>
      <Divider />
      <SportsFormFields sources={sources} firstFieldRef={firstFieldRef} onCancel={onCancel} />
    </Stack>
  );
};

export default MultiDataSourcesForm;
